import { STORAGE_KEYS } from '@/platform/auth-runtime/token-storage';

const RELEVANT_KEYS: string[] = [STORAGE_KEYS.token, STORAGE_KEYS.ubid];

// One logical sign-out in another tab arrives here as TWO storage events —
// tokenStorage.clear() removes both token and ubid. The first event owns the
// whole flow; without this in-flight latch the second would find the
// sign-out lock taken, hit the fallback below, and replace the page while
// the re-signin alert is still on screen.
let reacting = false;

// Another tab rewrote the auth keys (sign-in / sign-out / account switch).
// Full-page reload (matching legacy) so main.ts re-bootstraps identity from
// whatever token is now in storage: a plain sign-out falls through the router
// guard to /login, an account switch re-runs fetchInfo under the new token. An
// SPA nav would keep the previous session's in-memory identity.
window.addEventListener('storage', (e) => {
  if (!e.key || !RELEVANT_KEYS.includes(e.key)) return;
  // Only react when this tab previously held the key: a login tab with no
  // prior session must not be torn out by another tab's sign-in.
  if (e.oldValue === null) return;
  if (reacting) return;
  reacting = true;
  // Lazy-import to break the auth → axios → router → auth module-load cycle.
  void Promise.all([import('@/lang'), import('@/platform/auth-runtime/sign-out-lock')])
    .then(async ([langMod, signOutLockMod]) => {
      // A DIFFERENT sign-out flow (WS forced logout / auth-error handler)
      // already owns the lock — skip the toast to avoid stacked modals, but
      // still reload to drop the stale in-memory session.
      if (!signOutLockMod.beginSignOut()) {
        window.location.reload();
        return;
      }
      try {
        const t = langMod.i18n.global.t;
        await ElMessageBox.alert(t('reSignin.desc'), t('reSignin.title'), {
          confirmButtonText: t('common.ok'),
          type: 'warning',
          customClass: 'sr-auth-dialog',
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
        }).catch(() => {});
        window.location.reload();
      } finally {
        // Guard against the lock latching forever if reload resolves async.
        signOutLockMod.endSignOut();
      }
    })
    .finally(() => {
      reacting = false;
    });
});

export {};
